<div id="trialVisitSchedule" class="details-view">
  <div class="details-view-results">
    <form [formGroup]="form">
      <div class="details-view-results-head">
        <p>Add Visits</p>
        <input type="number" formControlName="visitCount">

        <app-button text="Add" variant="secondary" [disabled]="form.invalid" (clicked)="addVisits()" />

        @if (saveBtnVisible) {
          <div style="margin-left: auto">
            <app-button text="Save Visit Schedule" [disabled]="isBusy" (clicked)="save()" />
          </div>
        }
      </div>
    </form>

    @if (!dataLoaded) {
      <div class="visit-list">
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '48px', width: '100%', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
      </div>
    } @else {
      <div *ngIf="visits.length" cdkDropList class="visit-list" (cdkDropListDropped)="drop($event)">
        <div class="visit-box" *ngFor="let visit of visits" cdkDrag>
          <div class="visit-box__left">
            <i class="fa fa-grip-dots-vertical" cdkDragHandle></i>
            <div class="visit-box__title">
              <span class="visit-title">{{ visit.title }}</span>
              <span class="visit-type-label" *ngIf="visit.typeLabel">{{ visit.typeLabel }}</span>
            </div>
          </div>
          <div class="button">
            <ng-container *ngIf="visit.studyPhase && trialBrandName?.toLowerCase() === 'adarx'; else phasePlaceholder">
              <span class="patient-study-phase-badge phase-{{ visit.studyPhase | lowercase }}">{{ visit.studyPhase }}</span>
            </ng-container>
            <ng-template #phasePlaceholder>
              <span class="patient-study-phase-badge phase-placeholder" aria-hidden="true"></span>
            </ng-template>

            <app-button text="Edit" variant="secondary" size="sm" [disabled]="!visit.editable" (clicked)="onEditTemplate(visit)" />
            <app-button text="Remove" variant="info" size="sm" (clicked)="removeVisit(visit)" />
          </div>

          <div *cdkDragPreview class="visit-box-preview">{{ visit.title }}</div>
        </div>
      </div>
    }

  </div>
</div>

<app-visit-schedule-modal #visitScheduleModal (changed)="onVisitTranslationUpdated($event)"></app-visit-schedule-modal>
